import React, { useState, useEffect } from 'react';
import { TextField, } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import './certificates.css'
import ApiService from "../../functions/apiService";
import CalendarLoader from '../../components/Calendar/CalendarLoader';

const ViewCertificate = (props) => {
  const { id, setViewModal, viewModal, setViewId } = props
  const [certificate, setCertificate] = useState('')
  const [loading, setLoading] = useState(false);

  const certificateData = () => {
    if (id) {
      setLoading(true)
      ApiService.get('/certificate-details/' + id)
        .then(({ data }) => {
          setCertificate(data?.data)
          setLoading(false)
        })
        .catch(() => {
        })
    }
  }

  useEffect(() => {
    certificateData()
  }, [])

  return (
    <>
      <Modal show={viewModal} size="md" onHide={() => {
        setViewModal(false)
        setViewId('')
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Certificate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className='my-1'>Certificate Name</label>
          <TextField className='mt-0 w-100' color='secondary' variant="outlined" label=""
            value={certificate?.Name} disabled />

          <label className='mt-3'>Members</label>
          <div className='txt-field'>
            {certificate?.certificate_employees?.map((cert) => (
              <div className='emp-pill'>{cert?.employee?.employee_assignment?.EA_Rank} {cert?.employee?.fullName}</div>
            ))}
          </div>

          {certificate?.certificate_positions && certificate?.certificate_positions.length > 0 &&
            <>
              <label className='mt-3'>Position</label>
              <div className='txt-field'>
                {certificate?.certificate_positions?.map((pos) => (
                  <div className='emp-pill'>{pos?.position?.SO_Desc}</div>
                ))}
              </div>
            </>
          }

          <label className='mt-3'>Description</label>
          <TextField className='mt-0 w-100 mb-3' color='secondary' variant="outlined" label="" multiline
            value={certificate.Description} disabled />

        </Modal.Body>
      </Modal>
    </>
  )
}
export default ViewCertificate